"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteEspaceMutation = exports.useEpscaeByIdQuery = exports.useGetEspacesQuery = exports.useAddOrUpdateEspaceMutation = exports.EspaceApi = exports.prepareHeaders = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const http_1 = require("../../http");
const storage_1 = require("../../storage");
const Utils_1 = require("../../Utils");
const prepareHeaders = (headers, { getState }) => {
    var _a, _b;
    const token = (_a = getState().user.token) !== null && _a !== void 0 ? _a : (_b = storage_1.AppStorage.getItem("user")) === null || _b === void 0 ? void 0 : _b.token;
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
};
exports.prepareHeaders = prepareHeaders;
exports.EspaceApi = (0, react_1.createApi)({
    reducerPath: "espaceApi",
    tagTypes: ["espace", "espaceList", "espaceById"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: exports.prepareHeaders,
    }),
    endpoints: (builder) => ({
        addOrUpdateEspace: builder.mutation({
            invalidatesTags: ["espace", "espaceList", "espaceById"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `spaces/${id}/`,
                        method: "POST",
                        body: data,
                    };
                }
                return {
                    url: `spaces/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        getEspaces: builder.query({
            providesTags: ["espaceList"],
            query: (query) => (0, Utils_1.QueryUrl)("spaces", query),
        }),
        epscaeById: builder.query({
            query: (id) => `spaces/${id}/`,
            providesTags: ["espaceById"],
        }),
        deleteEspace: builder.mutation({
            query: (id) => ({
                url: `spaces/${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["espace", "espaceList", "espaceById"],
        }),
    }),
});
exports.useAddOrUpdateEspaceMutation = exports.EspaceApi.useAddOrUpdateEspaceMutation, exports.useGetEspacesQuery = exports.EspaceApi.useGetEspacesQuery, exports.useEpscaeByIdQuery = exports.EspaceApi.useEpscaeByIdQuery, exports.useDeleteEspaceMutation = exports.EspaceApi.useDeleteEspaceMutation;
